<style>
.root {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  left: -100%;
  background-color: rgba(255,255,255, 0.8);
  transition: left 250ms ease-out;
  overflow-y: auto;
  z-index: 10;
}

@media (min-width: 768px) {
  .root {
    left: -400px;
    width: 400px;
  }
}

.isOpen {
  left: 0;
}

.btnClose {
  background-color:rgba(255,255,255, 0.8);
  padding: 0;
  margin: 0;
  width: 40px;
  height: 40px;
  margin-left: auto;
}

.list {
  list-style: none;
  padding-left: 0;
  margin-top: 0;
}

.list li {
  padding: 0.5rem 1rem;
  border-top: 1px solid;
}

.list li:last-child {
  border-bottom: 1px solid;
}
</style>
<script>
  export let isOpen = false;
  import { messages } from '../swStore';
  import Row from '../layout/Row.svelte';
</script>

<div class="root" class:isOpen={isOpen}>
  <Row>
    <h2>Messages</h2>
    <button on:click title="close" class="btnClose">
      &#10005;
    </button>
  </Row>
  <ul class="list">
    {#each $messages as msg}
      <li>{msg}</li>
    {/each}
  </ul>
</div>
